import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CedingSchemeTypeModel } from '../../Models/Models/Transfer/CedingSchemeTypeModel';

declare var IS_RUNNING_IN_APP_POOL;

export class CedingSchemeTypesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<CedingSchemeTypeModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/CedingSchemeTypes/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<CedingSchemeTypeModel>, any>(url, data);
  }
}

